export const Config = {
    CRM_API_URL: "https://crm.uengage.in/crm_api/",
    API_URL: "https://api.uengage.in/",
}
